import {
  Container,
  Row,
  Col,
  Button,
  Table,
  Card,
  CardBody,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Collapse,
  Carousel,
  CarouselItem,
  CarouselControl,
  CarouselIndicators,
  CarouselCaption,
  ListGroup,
  ListGroupItem,
  CardHeader,
  Badge,
} from "reactstrap";

import drag from "../../../assets/drag.svg";
import Placeholder from "../../../assets/images/Placeholder.gif";
import React, { useEffect, useState } from "react";
import Pass from "../../../components/Common/Pass";
import { get, del, put } from "../../../api/axios";
import endpoints from "../../../api/endpoints";
import { toast, Bounce } from "react-toastify";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import avatar from "../../../assets/images/personPlaceholder.png";
import passDesign1 from "../../../../src/assets/peach.svg";
import passDesign2 from "../../../../src/assets/green.svg";
import passDesign3 from "../../../../src/assets/purple.svg";
import { useSelector } from "react-redux";
import Cash from "../../../assets/images/bars.svg";
import Up from "../../../assets/images/trade-up.svg";
import Down from "../../../assets/images/trade-down.svg";
const GymDetails = (args) => {
  document.title = "Gym Detail | Elevated - Admin Dashboard";
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const gymId = location.state?.gymId;
  const [gymData, setGymData] = useState(null);
  const [walletData, setWalletData] = useState(null);
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(true);
  const toggleModal = () => setModalOpen(!modalOpen);
  const [modalOpen, setModalOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [stats, setStats] = useState([]);
  const formatNumber = (num) => {
    if (num >= 1000000000) {
      return (num / 1000000000)?.toFixed(2) + "B";
    } else if (num >= 1000000) {
      return (num / 1000000)?.toFixed(2) + "M";
    } else if (num >= 1000) {
      return (num / 1000)?.toFixed(2) + "K";
    }
    return isNaN(num) || num === null ? "0.00" : Number(num).toFixed(2);
  };
  const toggle = () => setIsOpen(!isOpen);
  const { appRole, userPermissions } = useSelector((state) => {
    return state.auth.currentUser;
  });
  useEffect(() => {
    if (gymId) {
      fetchGym(gymId);
      fetchWallet(gymId);
    }
  }, [gymId]);
  const fetchFinance = async () => {
    try {
      setLoading(true);
      const response = await get(`${endpoints.finance}/${gymId}`);
      if (response && response.data) {
        setStats(response.data.data[0] || []);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (gymId) {
      fetchFinance(gymId);
    }
  }, [gymId]);
  const fetchGym = async (id) => {
    setLoading(true);
    try {
      const response = await get(`${endpoints.gym}/${id}`);
      setGymData(response?.data?.data);
      setFile(response?.data?.data?.files);
    } catch (error) {
      console.error("Error fetching gym data:", error);
      setGymData(null);
    } finally {
      setLoading(false);
    }
  };
  const fetchWallet = async (id) => {
    setLoading(true);
    try {
      const response = await get(`${endpoints.wallet}?gymId=${id}`);
      setWalletData(response?.data?.data);
    } catch (error) {
      console.error("Error fetching Wallet data:", error);
      setWalletData(null);
    } finally {
      setLoading(false);
    }
  };
  const handleEditGym = () => {
    if (!gymId) {
      toast.error("Gym ID not available, unable to edit.");
      return;
    }

    navigate(`/edit-gyms/:id`, { state: { gymId: gymId } });
  };
  const handleVerified = async () => {
    const gymResponse = await put(`${endpoints.business}/${gymId}`, {
      verified: "true",
    });
    if (gymResponse.data.success) {
      fetchGym(gymId);
    }
  };
  const handleDeleteGym = async () => {
    if (!gymId) {
      toast.error("Gym ID not available, unable to delete.");
      return;
    }

    try {
      await del(`${endpoints.gym}/${gymId}`);
      toast.success(`Gym Deleted Successfully`, {
        position: "bottom-center",
        theme: "colored",
        transition: Bounce,
      });
      navigate("/list-gyms");
      setModalOpen(false);
    } catch (error) {
      console.error("Error deleting gym:", error);
      alert("Failed to delete the gym.");
      setModalOpen(false);
    }
  };
  const formatTime = (time) => {
    const [hours, minutes] = time?.split(":");
    const date = new Date();
    date.setHours(hours);
    date.setMinutes(minutes);

    const options = { hour: "2-digit", minute: "2-digit", hour12: true };
    return date.toLocaleTimeString([], options);
  };
  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);

  const next = () => {
    if (animating) return;
    const nextIndex =
      activeIndex === gymData?.files?.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const previous = () => {
    if (animating) return;
    const nextIndex =
      activeIndex === 0 ? gymData?.files?.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  const goToIndex = (newIndex) => {
    if (animating) return;
    setActiveIndex(newIndex);
  };

  return (
    <Container fluid>
      <Card className="rounded-4 p-2 mb-2">
        <Row className="justify-content-between align-items-center p-2">
          <Col xs="12" md="6">
            <h2 className="card-title fw-bold ff-sora font-size-20 primary-black">
              Gym Details
            </h2>
          </Col>
          <Col
            xs="12"
            className="d-flex justify-content-center justify-content-md-end flex-column flex-sm-row"
          >
            {userPermissions?.gym?.["Delete Gym"] && (
              <Button
                color="white"
                className="rounded-pill1 me-2 mb-2 mb-md-0"
                onClick={() => setModalOpen(true)}
              >
                Delete Gym
              </Button>
            )}
            {userPermissions?.gym?.["Update Gym"] && (
              <Button
                className="rounded-pill me-2 mb-2 mb-md-0"
                onClick={handleEditGym}
              >
                Edit Gym
              </Button>
            )}
            {(appRole === "admin" || appRole === "staff") &&
              gymData?.verified !== true &&
              gymData?.companyTaxId && (
                <Button className="rounded-pill" onClick={handleVerified}>
                  Verified
                </Button>
              )}
          </Col>
          <Modal
            isOpen={modalOpen}
            toggle={toggleModal}
            className="modal-dialog-centered rounded-4"
          >
            <ModalHeader
              toggle={toggleModal}
              className="font-size-16 fw-medium ff-sora"
            >
              Confirm Deletion
            </ModalHeader>
            <ModalBody className="font-size-14 fw-normal ff-sora">
              Are you sure you want to delete this gym?
            </ModalBody>
            <ModalFooter>
              <Button
                type="submit"
                className=" rounded-pill"
                onClick={handleDeleteGym}
              >
                Confirm
              </Button>
              <Button
                color="white"
                className="rounded-pill1"
                onClick={toggleModal}
              >
                Cancel
              </Button>
            </ModalFooter>
          </Modal>
        </Row>
        <Row className="justify-content-between align-items-center rounded-4 px-2">
          <Col xs="12" className="bg-light pt-2 ">
            <div>
              {loading ? (
                <div className="text-center ff-sora fw-normal font-size-16">
                  Loading...
                </div>
              ) : gymData?.files?.length > 0 ? (
                <Carousel
                  activeIndex={activeIndex}
                  next={next}
                  previous={previous}
                >
                  <CarouselIndicators
                    items={gymData.files}
                    activeIndex={activeIndex}
                    onClickHandler={goToIndex}
                  />
                  {gymData.files.map((file, index) => (
                    <CarouselItem
                      className="custom-tag"
                      tag="div"
                      key={index}
                      onExiting={() => setAnimating(true)}
                      onExited={() => setAnimating(false)}
                    >
                      <div style={{ position: "relative" }}>
                        {/* Image */}
                        <img
                          src={`${process.env.REACT_APP_IMG_URL}${file.data}`}
                          className="d-block w-100 object-fit-cover"
                          alt={`gym-image-${index}`}
                          style={{ height: "500px" }}
                        />
                        {/* Text Overlay */}
                        <div
                          style={{
                            position: "absolute",
                            top: "0",
                            left: "0",
                            width: "40%",
                            height: "100%",
                            background:
                              "linear-gradient(to right, rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0.05))",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "end",
                            alignItems: "start",
                            color: "white",
                            padding: "20px",
                          }}
                        >
                          <div className="d-flex flex-row align-items-center">
                            {gymData?.logo && (
                              <>
                                <img
                                  src={`${process.env.REACT_APP_IMG_URL}${gymData?.logo?.data}`}
                                  className="object-fit-contain rounded-5 me-3"
                                  style={{
                                    height: "40px",
                                    width: "40px",
                                    border: "1px solid white",
                                  }}
                                  alt={`gym-image-${gymData?.logo?.data}`}
                                />
                              </>
                            )}
                            <p className="font-size-20 ff-sora fw-normal m-0">
                              {gymData?.name}
                            </p>
                          </div>
                          <p className="d-flex flex-row">
                            <span className=" font-size-16 ff-sora fw-normal me-2">
                              Address:
                            </span>
                            <span className="font-size-16 ff-sora fw-normal">
                              {gymData?.location?.formatted_address}
                            </span>
                          </p>
                        </div>
                      </div>
                    </CarouselItem>
                  ))}
                  <CarouselControl
                    direction="prev"
                    directionText="Previous"
                    onClickHandler={previous}
                  />
                  <CarouselControl
                    direction="next"
                    directionText="Next"
                    onClickHandler={next}
                  />
                </Carousel>
              ) : (
                <Row className="">
                  <Col
                    xs="12"
                    className="d-flex align-items-center justify-content-center"
                  >
                    <img
                      src={avatar}
                      className="avatar-xs rounded-2 font-size-14 ff-sora fw-normal object-fit-cover"
                      alt="default-avatar"
                      style={{
                        width: "200px",
                        height: "150px",
                      }}
                    />
                  </Col>
                </Row>
              )}
            </div>
          </Col>
        </Row>
      </Card>
      <Row className="gx-2">
        <Col xs={12} md={6}>
          <Card className="rounded-4  mb-2 ">
            <CardHeader
              className="p-0 m-0 light-green"
              style={{
                borderTopLeftRadius: "15px",
                borderTopRightRadius: "15px",
                color: "white",
              }}
            >
              <p className=" font-size-18 ff-sora fw-bold px-3 py-3 mb-0 ">
                Gym Detail
              </p>
            </CardHeader>

            <CardBody
              className="hide-scrollbar p-2 m-0"
              style={{ height: "525px", overflowY: "auto" }}
            >
              <ListGroup>
                <ListGroupItem className="fw-normal ff-sora ">
                  <span className="light-black font-size-14 pe-2">
                    Description:
                  </span>
                  <span className="secondary-black font-size-14">
                    {gymData?.description}
                  </span>
                </ListGroupItem>
                <ListGroupItem className="fw-normal ff-sora d-flex flex-wrap flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center">
                  <div className="mb-2 mb-sm-0">
                    <span className="light-black font-size-14 pe-2">
                      Email:
                    </span>
                    <span className="secondary-black font-size-14">
                      {gymData?.email?.slice(0, 20) +
                        (gymData?.email?.length > 20 ? "..." : "")}
                    </span>
                  </div>
                  <div>
                    <span className="light-black font-size-14 pe-2">
                      Contact No.:
                    </span>
                    <span className="secondary-black font-size-14">
                      {gymData?.phoneNumber}
                    </span>
                  </div>
                </ListGroupItem>

                <ListGroupItem className="fw-normal ff-sora d-flex flex-wrap flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center">
                  <div className="mb-2 mb-sm-0">
                    <span className="light-black font-size-14 pe-2">
                      Website:
                    </span>
                    <a
                      className="secondary-black font-size-14 ff-sora fw-normal"
                      href={`http://${gymData?.website}`}
                    >
                      {gymData?.website?.slice(0, 20) +
                        (gymData?.website?.length > 20 ? "..." : "")}
                    </a>
                  </div>
                  <div>
                    <span className="light-black font-size-14 pe-2">
                      Social Links:
                    </span>
                    <span className="secondary-black font-size-14 ff-sora fw-normal">
                      <a href={gymData?.socialInfo?.facebook}>Facebook </a>
                    </span>
                    <span className="secondary-black font-size-14 ff-sora fw-normal">
                      <a href={gymData?.socialInfo?.instagram}>Instagram </a>
                    </span>
                  </div>
                </ListGroupItem>
                <ListGroupItem className="fw-normal ff-sora d-flex flex-wrap flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center">
                  <div className="mb-2 mb-sm-0">
                    <span className="light-black font-size-14 pe-2">
                      Gym Tag:
                    </span>
                    <span className="secondary-black font-size-14">
                      {typeof gymData?.gymTag == "string"
                        ? gymData?.gymTag
                        : gymData?.gymTag
                            ?.map(
                              (tag) =>
                                tag.charAt(0).toUpperCase() +
                                tag.slice(1).toLowerCase()
                            ) // Capitalize first letter and make rest lowercase
                            ?.join(", ")}
                    </span>
                  </div>
                  <div>
                    <span className="light-black font-size-14 pe-2">
                      Gym Owner:
                    </span>
                    <span className="secondary-black font-size-14">
                      {`${
                        gymData?.gymOwnerId?.firstName != null
                          ? gymData?.gymOwnerId?.firstName
                          : ""
                      } ${
                        gymData?.gymOwnerId?.lastName != null
                          ? gymData?.gymOwnerId?.lastName
                          : ""
                      }`}
                    </span>
                  </div>
                </ListGroupItem>
                <ListGroupItem className="fw-normal ff-sora d-flex">
                  <div className="light-black font-size-14 pe-2 ">
                    Gym Category:
                  </div>
                  <div className="me-2">{gymData?.gymCategory?.title}</div>
                </ListGroupItem>
                <ListGroupItem className="fw-normal ff-sora d-flex">
                  <div className="light-black font-size-14 pe-2 ">
                    Amenities:
                  </div>
                  <div className="row">
                    {gymData?.amenities?.map((_, index) => (
                      <div className="col-md-4" key={index}>
                        <div
                          className="ff-sora secondary-black fw-normal font-size-14 "
                          key={index + 1}
                        >
                          <div className="ff-sora secondary-black fw-normal font-size-14 d-flex flex-row">
                            <img
                              src={
                                _.image == null
                                  ? avatar
                                  : `${process.env.REACT_APP_IMG_URL}${_.image}`
                              }
                              alt={_.name}
                              style={{
                                width: 25,
                                height: 25,
                                marginRight: 10,
                              }}
                            />
                            <p>{_.name}</p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </ListGroupItem>
                <ListGroupItem className="fw-normal ff-sora ">
                  <span className="light-black font-size-14 pe-2">
                    Special Info:
                  </span>
                  <ul>
                    {gymData?.specialInfo.map((_, index) => (
                      <li
                        className="ff-sora secondary-black fw-normal font-size-14"
                        key={index + 1}
                      >
                        <div dangerouslySetInnerHTML={{ __html: _ }}></div>
                      </li>
                    ))}
                  </ul>
                </ListGroupItem>
              </ListGroup>
            </CardBody>
          </Card>
        </Col>
        <Col xs={12} md={6}>
          <Card className="rounded-4  mb-2 ">
            <CardHeader
              className="p-0 m-0 light-green"
              style={{
                borderTopLeftRadius: "15px",
                borderTopRightRadius: "15px",

                color: "white",
              }}
            >
              <p className=" font-size-18 ff-sora fw-bold px-3 py-3 mb-0 ">
                Working Hour
              </p>
            </CardHeader>
            <CardBody
              className="hide-scrollbar p-2 m-0"
              style={{ height: "227px", overflowY: "auto" }}
            >
              <ListGroup>
                {loading ? (
                  <tr className="d-flex justify-content-center align-items-center text-center ff-sora fw-normal font-size-16">
                    <td colSpan={8} className="text-center">
                      <div className="d-flex justify-content-center align-items-center">
                        <div
                          className="spinner-border"
                          style={{
                            width: "3rem",
                            height: "3rem",
                            color: "#3BABA6",
                          }}
                          role="status"
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    </td>
                  </tr>
                ) : !loading && gymData?.length === 0 ? (
                  <div className="d-flex justify-content-center align-items-center text-center ff-sora fw-normal font-size-16">
                    <div>
                      <img
                        src={Placeholder}
                        alt="logo"
                        className="object-fit-contain image-fluid h-25 w-25 rounded-3 me-2"
                      />
                      <div className="mt-3">No Record Found!</div>
                    </div>
                  </div>
                ) : (
                  Array.isArray(gymData?.openingSchedule) &&
                  gymData?.openingSchedule.map(
                    (_, index) =>
                      _.openTime &&
                      _.closeTime && (
                        <ListGroupItem
                          key={index}
                          className="d-flex justify-content-between align-items-center "
                        >
                          <span className="ff-sora border-0 light-black fw-normal font-size-14">
                            {_.workingDay}
                          </span>
                          <span className="ff-sora secondary-black fw-normal font-size-14">{`${formatTime(
                            _.openTime
                          )} - ${formatTime(_.closeTime)}`}</span>
                        </ListGroupItem>
                      )
                  )
                )}
              </ListGroup>
            </CardBody>
          </Card>

          <Card className="rounded-4  mb-2 ">
            <CardHeader
              className="p-0 m-0 light-green"
              style={{
                borderTopLeftRadius: "15px",
                borderTopRightRadius: "15px",

                color: "white",
              }}
            >
              <p className=" font-size-18 ff-sora fw-bold px-3 py-3 mb-0 ">
                Financial Stats
              </p>
            </CardHeader>
            <CardBody
              className=""
              style={{ height: "227px", overflowY: "auto" }}
            >
              <Row className="gx-2">
                <Col xs={12}>
                  <Card className="p-3 d-flex flex-column justify-content-between rounded-4 pb-0 mb-2 d-block">
                    <div className="d-flex justify-content-between align-items-center">
                      <div
                        className="ff-sora font-size-16 fw-normal"
                        style={{
                          height: "50px",
                        }}
                      >
                        <h5 className="ff-sora font-size-24 fw-medium">
                          Current Month
                        </h5>
                        <p
                          className="ff-sora  fw-medium"
                          style={{ fontSize: "40px" }}
                        >
                          $
                          {formatNumber(parseFloat(stats.currentMonthAmount))
                            ? formatNumber(parseFloat(stats.currentMonthAmount))
                            : "0"}
                        </p>
                      </div>
                      <div
                        className="rounded-5 d-flex justify-content-center bg-brand-orange align-items-center "
                        style={{
                          width: "50px",
                          height: "50px",
                        }}
                      >
                        <img src={Cash} alt="cash" />
                      </div>
                    </div>
                    <div className=" ff-sora font-size-16 light-black d-flex justify-content-between align-items-center fw-normal pt-5">
                      <p>
                        Passes Redeem:{" "}
                        {stats.currentMonthCount
                          ? stats.currentMonthCount
                          : "0"}
                      </p>
                      <div className="d-flex justify-content-center align-items-center">
                        <img src={Up} alt="cash" />
                      </div>
                    </div>
                  </Card>
                </Col>
                <Col xs={12}>
                  <Card className="p-3 d-flex flex-column justify-content-between rounded-4 pb-0 mb-2">
                    <div className="d-flex justify-content-between align-items-center">
                      <div
                        className="ff-sora font-size-16 fw-normal"
                        style={{
                          height: "50px",
                        }}
                      >
                        <h5 className="ff-sora font-size-24 fw-medium">
                          Current Week
                        </h5>
                        <p
                          className="ff-sora  fw-medium"
                          style={{ fontSize: "40px" }}
                        >
                          ${formatNumber(parseFloat(stats.currentWeekAmount))}
                        </p>
                      </div>
                      <div
                        className="rounded-5 d-flex justify-content-center bg-brand-orange align-items-center "
                        style={{
                          width: "50px",
                          height: "50px",
                        }}
                      >
                        <img src={Cash} alt="cash" />
                      </div>
                    </div>
                    <div className=" ff-sora font-size-16 light-black d-flex justify-content-between align-items-center fw-normal pt-5">
                      <p>
                        Passes Redeem:{" "}
                        {stats.currentMonthCount
                          ? stats.currentMonthCount
                          : "0"}
                      </p>
                      <div className="d-flex justify-content-center align-items-center">
                        <img src={Down} alt="cash" />
                      </div>
                    </div>
                  </Card>
                </Col>
                <Col xs={12}>
                  <Card className="p-3 d-flex flex-column justify-content-between rounded-4 pb-0 mb-2">
                    <div className="d-flex justify-content-between align-items-center">
                      <div
                        className=""
                        style={{
                          height: "50px",
                        }}
                      >
                        <h5 className="ff-sora font-size-24 fw-medium">
                          Last Month
                        </h5>
                        <p
                          className="ff-sora  fw-medium"
                          style={{ fontSize: "40px" }}
                        >
                          ${formatNumber(parseFloat(stats.lastMonthAmount))}
                        </p>
                      </div>
                      <div
                        className="rounded-5 d-flex justify-content-center bg-brand-orange align-items-center "
                        style={{
                          width: "50px",
                          height: "50px",
                        }}
                      >
                        <img src={Cash} alt="cash" />
                      </div>
                    </div>
                    <div className=" ff-sora font-size-16 light-black d-flex justify-content-between align-items-center fw-normal pt-5">
                      <p>
                        Passes Redeem:{" "}
                        {stats.currentMonthCount
                          ? stats.currentMonthCount
                          : "0"}
                      </p>
                      <div className="d-flex justify-content-center align-items-center">
                        <img src={Up} alt="cash" />
                      </div>
                    </div>
                  </Card>
                </Col>
                <Col xs={12}>
                  <Card className="p-3 d-flex flex-column justify-content-between rounded-4 pb-0 mb-2 m-0">
                    <div className="d-flex justify-content-between align-items-center">
                      <div
                        className="ff-sora font-size-16 fw-normal"
                        style={{
                          height: "50px",
                        }}
                      >
                        <h5 className="ff-sora font-size-24 fw-medium">
                          Current Year
                        </h5>
                        <p
                          className="ff-sora  fw-medium"
                          style={{ fontSize: "40px" }}
                        >
                          ${formatNumber(parseFloat(stats.totalYearAmount))}
                        </p>
                      </div>
                      <div
                        className="rounded-5 d-flex justify-content-center bg-brand-orange align-items-center "
                        style={{
                          width: "50px",
                          height: "50px",
                        }}
                      >
                        <img src={Cash} alt="cash" />
                      </div>
                    </div>
                    <div className=" ff-sora font-size-16 light-black d-flex justify-content-between align-items-center fw-normal pt-5">
                      <p>
                        Passes Redeem:{" "}
                        {stats.currentMonthCount
                          ? stats.currentMonthCount
                          : "0"}
                      </p>
                      <div className="d-flex justify-content-center align-items-center">
                        <img src={Down} alt="cash" />
                      </div>
                    </div>
                  </Card>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Row className="gx-2">
        <Col xs={12} md={6}>
          <Card className="rounded-4  mb-2 ">
            <CardHeader
              className="p-0 m-0 light-green"
              style={{
                borderTopLeftRadius: "15px",
                borderTopRightRadius: "15px",

                color: "white",
              }}
            >
              <p className=" font-size-18 ff-sora fw-bold px-3 py-3 mb-0 ">
                Business Verification Detail
              </p>
            </CardHeader>
            <CardBody
              className="hide-scrollbar p-2 m-0"
              style={{ height: "525px", overflowY: "auto" }}
            >
              <ListGroup>
                {/* Company Tax ID Section */}
                <ListGroupItem className="fw-normal ff-sora d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center">
                  <div className="mb-2 mb-sm-0">
                    <span className="light-black font-size-14 pe-2">
                      Company Tax ID:
                    </span>
                    <span className="secondary-black font-size-14">
                      {gymData?.companyTaxId}
                    </span>
                  </div>
                  {/* <div>
                    <span className="light-black font-size-14 pe-2">
                      Acceptance Date:
                    </span>
                    <span className="secondary-black font-size-14">
                      {gymData?.tosAcceptanceDate}
                    </span>
                  </div> */}
                </ListGroupItem>
                <ListGroupItem className="fw-normal ff-sora d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center">
                  {/* <div className="mb-2 mb-sm-0">
                    <span className="light-black font-size-14 pe-2">
                      Acceptance IP:
                    </span>
                    <span className="secondary-black font-size-14">
                      {gymData?.tosAcceptanceIp}
                    </span>
                  </div> */}
                  <div>
                    <span className="light-black font-size-14 pe-2">
                      State Issue ID:
                    </span>
                    <span className="secondary-black font-size-14">
                      {gymData?.stateIssuedIDCard}
                    </span>
                  </div>
                  <div>
                    <span className="light-black font-size-14 pe-2">City:</span>
                    <span className="secondary-black font-size-14">
                      {gymData?.companyAddressCity}
                    </span>
                  </div>
                </ListGroupItem>
                <ListGroupItem className="fw-normal ff-sora">
                  <div>
                    <span className="light-black font-size-14 pe-2">
                      Address Line:
                    </span>
                    <span className="secondary-black font-size-14">
                      {gymData?.companyAddressLine1}
                    </span>
                  </div>
                </ListGroupItem>

                <ListGroupItem className="fw-normal ff-sora d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center">
                  <div className="mb-2 mb-sm-0">
                    <span className="light-black font-size-14 pe-2">
                      Postal Code:
                    </span>
                    <span className="secondary-black font-size-14">
                      {gymData?.companyAddressPostalCode}
                    </span>
                  </div>
                  <div>
                    <span className="light-black font-size-14 pe-2">
                      State:
                    </span>
                    <span className="secondary-black font-size-14">
                      {gymData?.companyAddressState}
                    </span>
                  </div>
                </ListGroupItem>
                {/* <ListGroupItem className="fw-normal ff-sora d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center">
                  <div className="mb-2 mb-sm-0">
                    <span className="light-black font-size-14 pe-2">
                      External Account:
                    </span>
                    <span className="secondary-black font-size-14">
                      {gymData?.externalAccount}
                    </span>
                  </div>
                  <div>
                    <span className="light-black font-size-14 pe-2">
                      Passport Card:
                    </span>
                    <span className="secondary-black font-size-14">
                      {gymData?.passportCard}
                    </span>
                  </div>
                </ListGroupItem>
                <ListGroupItem className="fw-normal ff-sora d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center">
                  <div className="mb-2 mb-sm-0">
                    <span className="light-black font-size-14 pe-2">
                      Driver License:
                    </span>
                    <span className="secondary-black font-size-14">
                      {gymData?.driverLicense}
                    </span>
                  </div>
               
                </ListGroupItem>
                <ListGroupItem className="fw-normal ff-sora d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center">
                  <div className="mb-2 mb-sm-0">
                    <span className="light-black font-size-14pe-2">
                      Resident Permit ID:
                    </span>
                    <span className="secondary-black font-size-14">
                      {gymData?.residentPermitID}
                    </span>
                  </div>
                  <div>
                    <span className="light-black font-size-14 pe-2">
                      Bank Account Number:
                    </span>
                    <span className="secondary-black font-size-14">
                      {gymData?.bankAccountNumber}
                    </span>
                  </div>
                </ListGroupItem>
                <ListGroupItem className="fw-normal ff-sora d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center">
                  <div className="mb-2 mb-sm-0">
                    <span className="light-black font-size-14 pe-2">
                      Passport:
                    </span>
                    <span className="secondary-black font-size-14">
                      {gymData?.passport}
                    </span>
                  </div>
                  <div>
                    <span className="light-black font-size-14 pe-2">
                      NYC Card:
                    </span>
                    <span className="secondary-black font-size-14">
                      {gymData?.nycCard}
                    </span>
                  </div>
                </ListGroupItem> */}

                <ListGroupItem className="fw-normal ff-sora">
                  <span className="light-black font-size-14 pe-2">
                    Company Verification Document:
                  </span>
                  {gymData?.companyVerificationDocument?.data ? (
                    <img
                      src={`${process.env.REACT_APP_IMG_URL}${gymData.companyVerificationDocument.data}`}
                      alt="Company Verification Document"
                      className="rounded-3 object-fit-contain mt-1"
                      style={{
                        height: "156px",
                        width: "230px",
                      }}
                    />
                  ) : (
                    "No Image attached"
                  )}
                </ListGroupItem>

                {/* <ListGroupItem className="fw-normal ff-sora">
                  <span className="light-black font-size-14 pe-2">
                    Bank Account Statement:
                  </span>
                  {gymData?.bankAccountStatement?.data ? (
                    <img
                      src={`${process.env.REACT_APP_IMG_URL}${gymData.bankAccountStatement.data}`}
                      alt="Bank Account Statement"
                      className="rounded-3 object-fit-cover mt-1"
                      style={{
                        height: "156px",
                        width: "230px",
                      }}
                    />
                  ) : (
                    "No Image attached"
                  )}
                </ListGroupItem>

                <ListGroupItem className="fw-normal ff-sora">
                  <span className="light-black font-size-14 pe-2">
                    Bank Letter:
                  </span>
                  {gymData?.bankLetter?.data ? (
                    <img
                      src={`${process.env.REACT_APP_IMG_URL}${gymData.bankLetter.data}`}
                      alt="Bank Letter"
                      className="rounded-3 object-fit-contain mt-1"
                      style={{
                        height: "156px",
                        width: "230px",
                      }}
                    />
                  ) : (
                    "No Image attached"
                  )}
                </ListGroupItem> */}
              </ListGroup>
            </CardBody>
          </Card>
        </Col>
        <Col xs={12} md={6}>
          <Card className="rounded-4  mb-2 ">
            <CardHeader
              className="p-0 m-0 light-green"
              style={{
                borderTopLeftRadius: "15px",
                borderTopRightRadius: "15px",

                color: "white",
              }}
            >
              <p className=" font-size-18 ff-sora fw-bold px-3 py-3 mb-0 ">
                Gym Passes
              </p>
            </CardHeader>
            <CardBody
              className="hide-scrollbar  p-2  m-0"
              style={{ height: "525px", overflowY: "auto" }}
            >
              <ListGroup>
                {loading ? (
                  <tr className="d-flex justify-content-center align-items-center text-center ff-sora fw-normal font-size-16">
                    <td colSpan={8} className="text-center">
                      <div className="d-flex justify-content-center align-items-center">
                        <div
                          className="spinner-border"
                          style={{
                            width: "3rem",
                            height: "3rem",
                            color: "#3BABA6",
                          }}
                          role="status"
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    </td>
                  </tr>
                ) : !loading && gymData?.Pass.length === 0 ? (
                  <div className="d-flex justify-content-center align-items-center text-center ff-sora fw-normal font-size-16">
                    <div>
                      <img
                        src={Placeholder}
                        alt="logo"
                        className="object-fit-contain image-fluid h-25 w-25 rounded-3 me-2"
                      />
                      <div className="mt-3">No Record Found!</div>
                    </div>
                  </div>
                ) : (
                  Array.isArray(gymData?.Pass) &&
                  gymData?.Pass.map(
                    (pass, index) =>
                      pass.dataStatus == "active" && (
                        <ListGroupItem key={index} className="d-flex flex-wrap">
                          <Pass
                            code={
                              pass.name +
                              pass.coinsPrice +
                              pass.duration +
                              gymData?.name
                            }
                            name={pass.name}
                            price={pass.price * 10}
                            duration={pass.duration}
                            filter={
                              pass.duration === "oneday"
                                ? passDesign1
                                : pass.duration === "oneweek"
                                ? passDesign2
                                : passDesign3
                            }
                            address={gymData?.name}
                            createdAt={pass?.createdAt}
                          />
                        </ListGroupItem>
                      )
                  )
                )}
              </ListGroup>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <Card className="rounded-4  mb-2 ">
            <CardHeader
              className="p-0 m-0 light-green"
              style={{
                borderTopLeftRadius: "15px",
                borderTopRightRadius: "15px",

                color: "white",
              }}
            >
              <p className=" font-size-18 ff-sora fw-bold px-3 py-3 mb-0 ">
                Pass Listing
              </p>
            </CardHeader>
            <CardBody>
              <div
                className="table-responsive hide-scrollbar rounded-4"
                style={{
                  height: gymData?.Pass?.length > 0 ? "400px" : "auto",
                }}
              >
                {loading ? (
                  <div className="text-center ff-sora font-size-16 fw-normal">
                    {/* //loading... */}
                  </div>
                ) : (
                  <Table
                    hover
                    className="table-borderless table-centered table-nowrap"
                  >
                    <thead>
                      <tr>
                        <th className="primary-black fw-bold ff-sora font-size-14">
                          Id
                        </th>
                        <th className="primary-black fw-bold ff-sora font-size-14">
                          Pass Title
                        </th>
                        <th className="primary-black fw-bold ff-sora font-size-14">
                          Pass Type
                        </th>
                        <th className="primary-black fw-bold ff-sora font-size-14">
                          Pass Price
                        </th>
                        <th className="primary-black fw-bold ff-sora font-size-14">
                          Total Sold
                        </th>
                        <th className="primary-black fw-bold ff-sora font-size-14">
                          Added On
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan={8} className="text-center">
                            <div className="d-flex justify-content-center align-items-center">
                              <div
                                className="spinner-border"
                                style={{
                                  width: "3rem",
                                  height: "3rem",
                                  color: "#3BABA6",
                                }}
                                role="status"
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </div>
                            </div>
                          </td>
                        </tr>
                      ) : !loading && gymData?.Pass.length === 0 ? (
                        <tr>
                          <td
                            colSpan="6"
                            className="text-center ff-sora fw-normal font-size-16"
                          >
                            <div>
                              <img
                                src={Placeholder}
                                alt="logo"
                                className="object-fit-contain image-fluid h-25 w-25 rounded-3 me-2"
                              />
                              <div className="mt-3">No Record Found!</div>
                            </div>
                          </td>
                        </tr>
                      ) : (
                        gymData?.Pass.map(
                          (_, index) =>
                            _.dataStatus == "active" && (
                              <tr key={_.id}>
                                <td className="fw-normal ff-sora secondary-black font-size-14">
                                  {index + 1}
                                </td>
                                <td className="fw-normal ff-sora secondary-black font-size-14">
                                  {_.name}
                                </td>
                                <td className="fw-normal ff-sora secondary-black font-size-14">
                                  {_.duration === "oneday"
                                    ? "Daily"
                                    : _.duration === "oneweek"
                                    ? "Weekly"
                                    : _.duration === "onemonth"
                                    ? "Monthly"
                                    : "N/A"}
                                </td>
                                <td className="fw-normal ff-sora secondary-black font-size-14">
                                  <span>
                                    {" "}
                                    ${formatNumber(parseFloat(_.price)) || "0"}
                                  </span>
                                </td>
                                <td className="fw-normal ff-sora secondary-black font-size-14">
                                  {_.buyCount == null ? "0" : _.buyCount}
                                </td>
                                <td className="fw-normal ff-sora secondary-black font-size-14">
                                  {_.createdAt
                                    ? new Date(_.createdAt).toLocaleDateString()
                                    : "01-01-2025"}
                                </td>
                              </tr>
                            )
                        )
                      )}
                    </tbody>
                  </Table>
                )}
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <Card className="rounded-4  mb-2 ">
            <CardHeader
              className="p-0 m-0 light-green"
              style={{
                borderTopLeftRadius: "15px",
                borderTopRightRadius: "15px",

                color: "white",
              }}
            >
              <p className=" font-size-18 ff-sora fw-bold px-3 py-3 mb-0 ">
                Equipment Listing
              </p>
            </CardHeader>
            <CardBody>
              <>
                <div
                  className="table-responsive hide-scrollbar"
                  style={{
                    height: gymData?.Equipment?.length > 0 ? "400px" : "auto",
                  }}
                >
                  {loading ? (
                    <div className="text-center ff-sora fw-normal font-size-16">
                      {/* //loading... */}
                    </div>
                  ) : (
                    <Table
                      hover
                      className="table-borderless table-centered table-nowrap"
                    >
                      <thead>
                        <tr>
                          <th className="font-size-14 mb-1 fw-bold ff-sora secondary-black">
                            Id
                          </th>
                          <th className="font-size-14 mb-1 fw-bold ff-sora secondary-black">
                            Equipment
                          </th>
                          <th className="font-size-14 mb-1 fw-bold ff-sora secondary-black">
                            Branded
                          </th>
                          <th className="font-size-14 mb-1 fw-bold ff-sora secondary-black">
                            Category
                          </th>
                          <th className="font-size-14 mb-1 fw-bold ff-sora secondary-black">
                            Added on
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? (
                          <tr>
                            <td colSpan={8} className="text-center">
                              <div className="d-flex justify-content-center align-items-center">
                                <div
                                  className="spinner-border"
                                  style={{
                                    width: "3rem",
                                    height: "3rem",
                                    color: "#3BABA6",
                                  }}
                                  role="status"
                                >
                                  <span className="visually-hidden">
                                    Loading...
                                  </span>
                                </div>
                              </div>
                            </td>
                          </tr>
                        ) : !loading && gymData?.Equipment?.length === 0 ? (
                          <tr>
                            <td
                              colSpan="6"
                              className="text-center ff-sora fw-normal font-size-16"
                            >
                              <div>
                                <img
                                  src={Placeholder}
                                  alt="logo"
                                  className="object-fit-contain image-fluid h-25 w-25 rounded-3 me-2"
                                />
                                <div className="mt-3">No Record Found!</div>
                              </div>
                            </td>
                          </tr>
                        ) : (
                          gymData?.Equipment.map((_, index) => (
                            <tr key={index}>
                              <td className="font-size-14 mb-1 fw-normal ff-sora secondary-black">
                                {index + 1}
                              </td>
                              <td>
                                <div className="d-flex align-items-center">
                                  <img
                                    src={
                                      _?.file == null
                                        ? avatar
                                        : `${process.env.REACT_APP_IMG_URL}${_?.file}`
                                    }
                                    className="avatar-xs rounded-2 font-size-14 ff-sora fw-normal object-fit-cover me-2"
                                    alt={`${_?.firstName}'s avatar`}
                                  />
                                  <div>
                                    <h6 className="font-size-14 mb-1 fw-normal ff-sora secondary-black">
                                      {_?.name}
                                    </h6>
                                  </div>
                                </div>
                              </td>
                              <td className="font-size-14 mb-1 fw-normal ff-sora secondary-black">
                                {_?.brand}
                              </td>
                              <td className="font-size-14 mb-1 fw-normal ff-sora secondary-black">
                                {_?.category}
                              </td>
                              <td className="font-size-14 mb-1 fw-normal ff-sora secondary-black">
                                {_.createdAt
                                  ? new Date(_.createdAt).toLocaleDateString()
                                  : "N/A"}
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </Table>
                  )}
                </div>
              </>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <div
        className="d-flex justify-content-between align-items-center"
        style={{
          height: "50px",
          position: "sticky",
          bottom: "0",
          zIndex: "10",
        }}
      ></div>
    </Container>
  );
};

export default GymDetails;
